<form class="ui form" #form="ngForm">
    <ng-container *ngIf="survey">
        <app-segment-header title="surveys.store.surveySummaryForm.detailsTitle"></app-segment-header>
        <div class="six fields">
            <div class="field">
                <label class="font-medium">{{ 'surveys.store.surveySummaryForm.titleLabel' | translate }}</label>
                <div>{{ survey.title }}</div>
            </div>

            <div class="field survey-template">
                <label class="font-medium">{{ 'surveys.store.surveySummaryForm.templateLabel' | translate }}</label>
                {{ getSelectedTemplateName() }}
            </div>
        </div>

        <div class="three fields margin-bottom-3" *ngIf="survey.description">
            <div class="field survey-description">
                <label class="font-medium">{{ 'surveys.store.surveySummaryForm.descriptionLabel' | translate }}</label>
                <div class="ui segment">{{ survey.description }}</div>
            </div>
        </div>

        <mat-divider></mat-divider>

        <app-segment-header
            class="margin-top-3"
            title="surveys.store.surveySummaryForm.scheduleTitle"
        ></app-segment-header>
        <div class="three fields margin-bottom-3">
            <div class="field">
                <label class="font-medium">{{ 'surveys.store.surveySummaryForm.dueDateLabel' | translate }}</label>
                <div>{{ survey.dueAt | appDate: 'yyyy-MM-dd' }}</div>
            </div>
        </div>

        <mat-divider></mat-divider>

        <app-segment-header
            class="margin-top-3"
            title="surveys.store.surveySummaryForm.visibilityTitle"
        ></app-segment-header>
        <div class="three fields">
            <div class="field">
                <label class="font-medium">{{ 'surveys.store.surveySummaryForm.anonymousLabel' | translate }}</label>
                <div>{{ survey.isAnonymous ? 'yes' : 'no' }}</div>
            </div>
        </div>
    </ng-container>
</form>
